import { all, call } from "redux-saga/effects";
import { broadcastWatchSaga } from "./broadcast/sagas/broadcast-watch-saga";

export function* rootSaga() {
	yield all([call(broadcastWatchSaga)]);
}
